import { render } from "./Dashboard.vue?vue&type=template&id=29f45b92&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"

import "./Dashboard.vue?vue&type=style&index=0&id=29f45b92&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-29f45b92"

export default script